<template>
    <Card :header="$t('code')">
        <p>{{ $t('insertSelectedCodeAndAutomateDisplay') }}</p>
        <b-link :href="helperUrl" target="_blank">{{ helperText }}</b-link>

        <b-tabs v-model="activeTab" class="mt-3">
            <b-tab title="HTML">
                <div class="widget-code" v-html="htmlSnippet('html')"></div>
            </b-tab>
            <b-tab title="JSON">
                <div class="widget-code" v-html="jsonSnippet('html')"></div>
            </b-tab>
        </b-tabs>

        <ButtonIcon variant="primary" icon="copy" class="mt-3" @click="copyWidgetCode()">{{ $t('copyCode') }}</ButtonIcon>

    </Card>
</template>



<script>
    import camelCase from 'camelcase';
    import without from 'lodash/without';

    export default {
        name: 'ProductCode',
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestPlugin: this.parentComponent.requestPlugin,
                activeTab: 0,
            };
        },
        computed: {
            plugin() {
                return this.requestPlugin.getData();
            },
            product() {
                return this.parentComponent.product;
            },
            helperText() {
                return this.activeTab === 0 ? this.$t('howToInsertJsCode') : this.$t('howToInsertJsonCode');
            },
            helperUrl() {
                return this.activeTab === 0 ? 'https://help.100shoppers.com/pl/articles/2814129-javascript-standard' : 'https://help.100shoppers.com/pl/articles/3036892-json';
            },
            bbData() {
                return {
                    id: this.plugin?.id,
                    number: this.product?.ean,
                    sku: this.product?.sku,
                    name: this.product?.name,
                    category: (this.product?.categories?.length && this.product.categories.map(cat => cat.map(item => item.name).join(' > ')).join(' | ')),  // eslint-disable-line prettier-vue/prettier, max-len
                    price: this.product?.price,
                    description: this.product?.description,
                    image: this.product?.images?.[0],
                };
            },
            htmlSnippet() {
                return (type = 'html') => {
                    const domElementId = Math.random().toString(36).substring(2, 6);
                    const baseAttrsStr = `id="buybox-${domElementId}" class="bb-widget" `;
                    const attrsStr = baseAttrsStr + Object.keys(this.bbData).map(name => `data-bb-${name}="${this.getAttr(name)}"`).join(' ');  // eslint-disable-line prettier-vue/prettier, max-len
                    if (type === 'code') return `<div ${attrsStr.replaceAll('<mark>', '').replaceAll('</mark>', '')}></div>`;
                    return `&#60;div ${attrsStr}&#62;&#60;/div&#62;`;
                };
            },
            jsonSnippet() {
                return (type = 'html') => {
                    const baseAttrsStr = `${process.env.VUE_APP_WIDGET_API_URL}/${this.plugin?.id}/buybox.json?`;
                    const attrsStr = baseAttrsStr + without(Object.keys(this.bbData), 'id').map(name => `${name}=${this.getAttr(name)}`).join('&');  // eslint-disable-line prettier-vue/prettier, max-len
                    if (type === 'code') return attrsStr.replaceAll('<mark>', '').replaceAll('</mark>', '');
                    return attrsStr;
                };
            },
        },
        methods: {
            getAttr(attrName) {
                return this.bbData[attrName] || `<mark>${this.$tx(`productCode${camelCase(attrName, { pascalCase: true })}Placeholder`)}</mark>`;
            },
            async copyWidgetCode() {
                let widgetCode = '';
                if (this.activeTab === 0) widgetCode = this.htmlSnippet('code');
                if (this.activeTab === 1) widgetCode = this.jsonSnippet('code');
                await this.$copyText(widgetCode);
                this.$toastr.success(this.$t('widgetCodeCopiedSuccessful'));
            },
        },
    };
</script>



<style lang="scss" scoped>
    .widget-code {
        border: 1px solid $pre-color;
        border-radius: $border-radius;
        white-space: wrap;
        font-size: 90%;
        color: #6c757d;
        line-height: 150%;
        padding: 16px;
        white-space: preserve;
        word-break: break-word;
    }
</style>
